require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-tags-chrissy-stefani.json") })
        }
      }, "path---articles-tags-chrissy-stefani");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-tags-chrissy-stefani!./.cache/json/articles-tags-chrissy-stefani.json
// module id = 1766
// module chunks = 231608221292675